<template>
  <a-form-item
    validateTrigger="blur"
    label=""
    :name="props.nameProp"
    :rules="[
      { required: true, message: 'Enter the email address' },
      { type: 'email', message: 'Please enter a valid email address' },
    ]"
  >
    <a-auto-complete
      v-model:value="formState.email"
      :options="emailOptions"
      placeholder="Enter the email address"
      @search="handleEmailSearch"
      @select="handleEmailSelect"
      @keydown="handleEmailKeyDown"
      :input-props="{ autocomplete: 'email' }"
      maxlength="40"
      class="email_input"
      :popupClassName="'email_select_dropdown'"
    />
  </a-form-item>
</template>

<script setup>
import { ref, reactive, defineEmits, watch, defineProps } from 'vue';

const props = defineProps({
  nameProp: {
    type: String,
    default: 'email',
  },
  initialEmail: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change-email']);

const emailSuffixes = ['gmail.com', 'yahoo.com', 'outlook.com', 'icloud.com', 'hotmail.com'];
const emailOptions = ref([]);

const handleEmailSearch = (value) => {
  const atIndex = value.indexOf('@');
  if (atIndex >= 0) {
    const prefix = value.slice(0, atIndex);
    const inputSuffix = value.slice(atIndex + 1).toLowerCase();

    emailOptions.value = emailSuffixes
      .filter((suffix) => suffix.toLowerCase().includes(inputSuffix))
      .map((suffix) => ({ value: `${prefix}@${suffix}` }));

    if (emailOptions.value.length === 0) {
      emailOptions.value = [];
    }
  } else {
    emailOptions.value = [];
  }
};

const formState = reactive({
  email: '',
});

const handleEmailSelect = (value) => {
  formState.email = value;
};

const handleEmailKeyDown = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    formState.email = event.target.value;
    event.target.blur();
  }
};

watch(formState, (newVal) => {
  formState.email = newVal.email.trim();
  emit('change-email', newVal.email.trim());
});

watch(
  () => props.initialEmail,
  (val) => {
    if (val !== formState.email) {
      formState.email = val;
    }
  }
);
</script>

<style lang="less">
.email_input.ant-select {
  &.ant-select-status-error .ant-select-selector {
    border-color: #ff7875 !important;
  }
  .ant-select-selector {
    border: 1px solid rgba(5, 100, 79, 0.5) !important;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03) !important;
    border-radius: 16px;
    height: 46px;
    .ant-select-selection-search-input {
      font-size: 14px;
      padding: 10px 14px;
      height: auto;
      color: #05644f !important;
    }
    .ant-select-selection-placeholder {
      color: rgba(5, 100, 79, 0.33);
      font-size: 14px;
      line-height: 42px;
      margin-left: 14px;
    }
  }
}
</style>
